import styled from 'styled-components';

export default styled.td`
  font-family: monospace;
  padding: 0.25rem 1rem 0.25rem 0;
`;
